import { observer } from 'mobx-react-lite'
import type { ReactElement } from 'react'
import { useSearchParams } from 'react-router-dom'
import { AiAgentMyAgent } from 'app/components/ai-agent-settings/AiAgentMyAgent'
import Spinner from 'app/components/Spinner'
import { useLocationIntegrationStatus } from 'app/hooks/useLocationIntegrationStatus'
import { AgentLocationPicker } from './AgentLocationPicker'
import { AgentsShell } from './AgentsShell'

/** Agents → Settings: one practice's agent, which its staff can read and adjust. */
export const AgentsMyAgentPage = observer(function AgentsMyAgentPage(): ReactElement {
  const [searchParams, setSearchParams] = useSearchParams()
  const { locationOptions, isLoading } = useLocationIntegrationStatus([], [`AI Agent`, `SMS Agent`])
  const locationId =
    locationOptions.find((option) => option.value === searchParams.get(`locationId`))?.value ??
    locationOptions[0]?.value

  return (
    <AgentsShell
      actions={
        locationOptions.length > 1 && (
          <AgentLocationPicker
            options={locationOptions}
            value={locationId}
            onChange={(value) =>
              setSearchParams(
                (prev) => {
                  prev.set(`locationId`, value)
                  return prev
                },
                { replace: true },
              )
            }
          />
        )
      }
    >
      {locationId ? (
        <AiAgentMyAgent key={locationId} locationId={locationId} />
      ) : isLoading ? (
        <div className="flex justify-center py-16">
          <Spinner size={8} />
        </div>
      ) : (
        <p className="text-body-sm text-subtle">No practice in this workspace has an agent yet.</p>
      )}
    </AgentsShell>
  )
})
